module.exports = __webpack_public_path__ + "static/img/logo.db6da96.png";